import { inject, Injectable } from '@angular/core';
import { JwtUtil } from '@ribera-web/token-decodifier-service';

@Injectable({
  providedIn: 'root'
})
export class AuthSessionUtil {

  private jwtUtil = inject(JwtUtil);

  isLoggedIn(): boolean {
    const token = sessionStorage.getItem('accessToken');
    if (!token) return false;

    return !this.isTokenExpired(token);
  }

  isTokenExpired(token: string): boolean {
    try {
      const expiration = this.jwtUtil.getExpirationDate(token) * 1000;
      return Date.now() >= expiration;
    } catch {
      return true;
    }
  }
}
